import { TooltipDesignTokens } from '@primeuix/themes/types/tooltip';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tooltip/index.ts
const tt = componentColorScheme.tooltip;

export const TooltipTelekomDT: TooltipDesignTokens = {
  colorScheme: {
    light: {
      root: {
        background: t(tt.background),
        color: t(tt.color),
      },
    },
  },
};
